import { BaseSelectItem } from 'wbs-components-lib';

import { BetCoefficientTypesEnum } from '@shared/constants';

export const getCoefficientTypeSelectItems = () => {
  const selectItems: BaseSelectItem[] = Object.values(BetCoefficientTypesEnum).map((type) => ({
    id: type,
    value: type,
  }));

  return selectItems;
};
